// extracted by mini-css-extract-plugin
export var comment = "comment-item-module--comment--5XDNE";
export var commentAvatar = "comment-item-module--comment-avatar--hugUS";
export var commentContent = "comment-item-module--comment-content--XKpsU";
export var commentContentName = "comment-item-module--comment-content-name--Pg4Cf";
export var commentContentText = "comment-item-module--comment-content-text--ORLYI";